import { Routes, Route } from 'react-router-dom';
import EduStandard from './list';
import AddEduStandard from './add';
import EditEduStandard from './edit';
import ViewEduStandard from './view';

const EduStandardRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<EduStandard />} />
      <Route path="/add" element={<AddEduStandard />} />
      <Route path="/edit/:id" element={<EditEduStandard />} />
      <Route path="/view/:id" element={<ViewEduStandard />} />
    </Routes>
  );
};

export default EduStandardRoutes;
